import * as React from 'react';
import { connect } from 'dva';
import { Radio, Modal, Button } from 'antd';
import withEnhanceRouter from '@src/components/hoc/experiment/with-enhance-router';
import styles from './index.less';
import services from '@src/services/zt';
import SmsCodeInput from '@src/components/sms-code-input';
import DistrictSelect from '@src/components/district-select';
import $$tracker from '@src/$$tracker';
import { ANTIQUEACCOUNT_URL, SHARE_URL } from '@src/constants/urls';
import DeviceUtils from '@src/utils/device-utils';

@withEnhanceRouter
@connect(
  ({ example }) => ({ time: example.time }),
  dispatch => ({ updateTime: () => dispatch({ type: 'example/updateTime' }) })
)
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aid: 11, // 活动Id
      showPop: 1, // 鉴定流程面板Id
      showResult: 1, // 激活结果面板Id
      textValue: 0, // 活动鉴定总人数
      userAccount: '', // 用户账户
      userPassword: '', // 用户密码
      loginCode: '', // 登录验证码
      appraisalText: '', // 鉴定结果文案提示
      bindPhone: '', // 绑定手机号码
      userIdCard: '', // 用户身份证信息
      phoneCode: '', // 编译后电话号码
      verificationCode: '', // 短信验证码
      activateValue: 1, // 激活账号类型(1 当前账号/ 2 其他账号)
      newAccount: '', // 激活新账号号码
      checkNewAccount: '', // 检查新账号号码
      activationText: '', // 激活结果文案
      qrcodeUrl: '', // 二维码路径,
      errorStatus: false // 身份证是否为正确身份证
    };
  }

  componentWillMount() {
    window.onload = () => {
      // 获取活动配置信息
      this.getConfigMsg();
    };
  }

  /**
   * 获取活动配置项
   * */
  getConfigMsg() {
    const { aid } = this.state;
    services.getIdentifyTotal(aid).then(data => {
      const { total } = data;
      const { textValue } = this.state;
      this.setState({
        textValue: total
      });
    });
  }

  /**
   * 获取用户账户状态(是否激活)
   * */
  getUserStatus() {
    sessionStorage.setItem('activateStep', 2); // 记录当前鉴定流程步骤(2:鉴定结果; 3:绑定手机; 4:古董账号名单; 5:激活结果)
    const { aid } = this.state;
    services.getPlayerStatus(aid).then(data => {
      const { playerStatus, level, newAccount } = data;
      sessionStorage.setItem('userLevel', level);
      this.showResult(playerStatus, level, newAccount);
    });
  }

  /**
   * 根据账号状态显示面板
   * */
  showResult(playerStatus, level, newAccount) {
    //未激活
    if (playerStatus === 1 || playerStatus === 3) {
      const { aid } = this.state;
      services.getIdentifyResult(aid).then(data => {
        console.log(data);
        const { level: userLevel, bind_money: userBind_money, create_time, duration, account, diff_day, value } = data.result;
        if (userLevel === 0) {
          // 非古董账号
          sessionStorage.setItem('isAA', 0);
          this.showAppraisalResult(false, userLevel, userBind_money);
        } else {
          // 古董账号
          sessionStorage.setItem('isAA', 1);
          this.showAppraisalResult(true, userLevel, userBind_money, create_time, duration, account, diff_day, value);
        }
      });
    } else if (playerStatus === 2 || playerStatus === 4 || playerStatus === 5) {
      this.getActivateResult();
    }
  }

  /**
   * 显示鉴定结果
   * */
  async showAppraisalResult(status, level, bind_money, create_time, duration, account, diff_day, value) {
    const { aid, showPop, appraisalText } = this.state;
    let levelName = ['混天', '雏凤', '潜龙', '至尊', '无双', '超神'];
    let userLevel = levelName[level];
    let bindMoney = bind_money / 10000;
    let resultId; // 声明鉴定结果ID
    let createTime = new Date(parseInt(create_time + '000')).toLocaleDateString();
    let resultStr;
    if (status) {
      let accountTemp = account.split('');
      let shieldAccount = accountTemp[0] + '***' + accountTemp[accountTemp.length - 1];
      resultId = 3;
      resultStr = `亲爱的大侠，还记得<span class="spanTips">
         ${create_time}
        </span>与你初次相遇，少年意气英姿阔绰。<br />
        你曾纵马夺旗勇战金蒙，也曾兵戈戎马名载宋金。<br />   扬眉笑看烽火是你，挥剑纵歌天涯也是你……<br />
        身披日月与江湖共处的<b class="spanTips">
        ${duration}
        </b>个小时，你曾以江湖为家。弹指间岁月流年，
        你淡出江湖已有<b class="spanTips">
        ${diff_day}
        </b>天。而今江山无界战戈待起，人潮百里，回首希望有你的身影。<br />
        你在江湖付出的心血，经历的故事，我们都记得。<br />
        <span class="spanTips">
        ${shieldAccount}
        </span>经鉴定，价值<b class="spanTips">
        ${value}
        </b>元，获得<b class="spanTips">[
        ${userLevel}
        ]</b>等级，  
        激活并入驻新服即可领取<b class="spanTips" >
        ${bindMoney}万</b>绑金奖励。<div class="J_logOutPublicRegjs">[ 退出登录 ]</div>`;
    } else {
      resultStr =
        ' 亲爱的大侠，你提供的账号未达到古董账号评定条件，我们期待你的继续相伴，成长为古董账号的一天，特给予<b class="spanTips">[混天]</b>等级，激活并入驻新服即可领取<b class="spanTips">100万</b>绑金奖励！<div class="J_logOutPublicRegjs">[ 退出登录 ]</div>';
      resultId = 4;
    }
    let getToken = await services.getShareToken(aid);
    const { share_token } = getToken;
    let URL = `${SHARE_URL}${aid}/${share_token}/`;
    let requestQueryString = encodeURIComponent(
      JSON.stringify({
        value: URL
        // correctLevel: 1
      })
    );
    $$tracker.createQrc(level);
    var iframeAddress = `https://zhcdn01.xoyo.com/xassets/iframe/qr/0.0.x/?${requestQueryString}`;
    this.setState({
      appraisalText: resultStr,
      showPop: resultId,
      qrcodeUrl: iframeAddress
    });
  }

  /**
   * 验证身份
   * */
  activation() {
    $$tracker.clickJh1(); // 点击激活
    sessionStorage.setItem('activateStep', 3); // 记录当前鉴定流程步骤(2:鉴定结果; 3:绑定手机; 4:古董账号名单; 5:激活结果)
    this.checkBindPhone();
  }

  /**
   * 验证是否为正确的身份证号
   */
  isIdCard = idCard => {
    const { errorStatus } = this.state;
    let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
    if (!reg.test(idCard)) {
      this.setState({
        errorStatus: true
      });
    } else {
      this.setState({
        errorStatus: false
      });
    }
  };

  /**
   * 验证是否绑定手机
   * */
  checkBindPhone() {
    const { aid, showPop, bindPhone, phoneCode } = this.state;
    let resultId; // 根据是否有绑定手机声明跳转页面数值
    let userBindPhone;
    services
      .getBindMobile(aid)
      .then(data => {
        const { displayMobile, mobile } = data;
        if (mobile !== '') {
          userBindPhone = displayMobile;
          resultId = 5;
        } else {
          resultId = 6;
        }
        this.setState({
          showPop: resultId,
          phoneCode: mobile,
          bindPhone: displayMobile
        });
      })
      .catch(error => {
        // console.log(error);
        const { code, message } = error;
        if (code === -20105) {
          let resultId = 6;
          this.setState({
            showPop: resultId
          });
        } else {
          this.alertInfo('提示', message);
        }
      });
  }

  /**
   * 验证短信验证码
   * */
  async checkCode() {
    const { aid, phoneCode, verificationCode, showPop } = this.state;
    services
      .checkCode(aid, phoneCode, verificationCode)
      .then(data => {
        let isAA = parseInt(sessionStorage.getItem('isAA'));
        if (isAA > 0) {
          sessionStorage.setItem('activateStep', 4); // 记录当前鉴定流程步骤(2:鉴定结果; 3:绑定手机; 4:古董账号名单; 5:激活结果)
          this.setState({
            showPop: 7
          });
        } else {
          this.activateAccount();
        }
        $$tracker.clickJh2(1);
      })
      .catch(error => {
        const { message } = error;
        this.alertInfo('错误', message);
        $$tracker.clickJh2(0);
      });
  }

  /**
   * 选择激活账号选项(激活当前账号 / 激活其他账号)
   * */
  onChangeValue = e => {
    // console.log('radio checked', e.target.value);
    this.setState({
      activateValue: e.target.value
    });
  };

  /**
   * 激活账号
   * */
  activateAccount = () => {
    const { aid, activateValue, newAccount, checkNewAccount } = this.state;
    let userNewAccount;
    if (activateValue === 1) {
      //  激活当前账号
      userNewAccount = ''; // 激活当前账号,新账号为空
      services
        .activationAccount(aid, userNewAccount)
        .then(() => {
          // console.log(data);
          $$tracker.clickJh3(1);
          this.getActivateResult();
        })
        .catch(error => {
          $$tracker.clickJh3(0);
          const { message } = error;
          this.alertInfo('提示', message);
        });
    } else {
      //  激活其他账号
      if (newAccount === checkNewAccount) {
        services
          .activationAccount(aid, newAccount)
          .then(() => {
            $$tracker.clickJh3(1);
            this.getActivateResult();
          })
          .catch(error => {
            $$tracker.clickJh3(0);
            const { message } = error;
            this.alertInfo('提示', message);
          });
      } else {
        this.alertInfo('提示', '两次账号不一致，请重新输入');
      }
    }
  };
  checkAccount = e => {
    const { newAccount } = this.state;
    if (newAccount === e.target.value) {
    } else {
      this.setState({
        checkNewAccount: ''
      });
      this.alertInfo('输入错误', '两次账号不一致,请重新输入');
    }
  };

  /**
   * 获取激活结果
   * */
  getActivateResult = () => {
    sessionStorage.setItem('activateStep', 5); // 记录当前鉴定流程步骤(2:鉴定结果; 3:绑定手机; 4:古董账号名单; 5:激活结果)
    const { aid, qrcodeUrl } = this.state;
    services
      .getActivationResult(aid)
      .then(data => {
        // console.log(data);
        const { level, new_account, value, type } = data;
        sessionStorage.setItem('userLevel', level);
        let levelName = ['混天', '雏凤', '潜龙', '至尊', '无双', '超神'];
        let userLevel = levelName[level];
        let resultId;
        let resultStr;
        if (new_account === '') {
          if (type === 1) {
            resultId = 1;
            resultStr = `亲爱的大侠，你的账号鉴定等级为<b class="spanTips">[${userLevel}]</b>，你已成功激活奖励领取资格。<br />
            <div class="J_logOutPublicRegjs">[ 退出登录 ]</div>`;
          } else if (type === 2) {
            resultId = 2;
            resultStr = `亲爱的大侠，<br />
                  你所提供的账号经鉴定，价值<b class="spanTips">${value}元</b>，<br />
                  获得<b class="spanTips">[${userLevel}]</b>等级评定，你已成功激活奖励领取资格。`;
          } else if (type === 4) {
            resultId = 4;
            resultStr = `亲爱的大侠，<br />
                  你已获赠价值<b class="spanTips">${value}元</b>的<b class="spanTips">[${userLevel}]</b>等级评定的账号特权，该奖励领取资格已被激活。<br/>
                  <div class="J_logOutPublicRegjs">[ 退出登录 ]</div>`;
          }
        } else {
          resultId = 3;
          resultStr = `亲爱的大侠，<br />
         你已将资格转移至<b class="spanTips">${new_account}</b><br />
         <div class="J_logOutPublicRegjs">[ 退出登录 ]</div>`;
        }
        if (qrcodeUrl === '') {
          this.setShareUrl();
        }
        this.setState({
          showPop: 8,
          showResult: resultId,
          activationText: resultStr
        });
      })
      .catch(error => {
        const { message } = error;
        this.alertInfo('提示', message);
      });
  };

  /**
   * 设置分享的URL地址
   * */
  async setShareUrl() {
    const { aid, qrcodeUrl } = this.state;
    // 获取分享token
    let getToken = await services.getShareToken(aid);
    const { share_token } = getToken;
    // let URL =
    //   process.env.DEPLOY_ENV === 'master'
    //     ? `https://jxsj.xoyo.com/m/2019/07/08/antique/index.html?utme_souce=qrcode/#/${aid}/${share_token}/`
    //     : `https://test-zt.xoyo.com/jxsj.xoyo.com/m/2019/07/08/antique/index.html?utme_souce=qrcode/#/${aid}/${share_token}/`;
    let URL = `${SHARE_URL}${aid}/${share_token}/`;
    let requestQueryString = encodeURIComponent(
      JSON.stringify({
        value: URL
      })
    );

    let iframeAddress = `https://zhcdn01.xoyo.com/xassets/iframe/qr/0.0.x/index.html?${requestQueryString}`;
    let userLevel = sessionStorage.getItem('userLevel');
    $$tracker.createQrc(userLevel);
    this.setState({
      qrcodeUrl: iframeAddress
    });
  }

  /**
   * 登录成功后调用增加鉴定人数
   * */
  addCount() {
    const { aid } = this.state;
    services.saddIdentify(aid).then(data => {
      // console.log(data);
    });
  }

  /**
   * 显示鉴定中页面
   * */
  showLoading = () => {
    const { showPop } = this.state;
    this.setState({
      showPop: 2
    });
    setTimeout(() => {
      // 获取玩家状态
      this.getUserStatus();
    }, 2000);
  };

  /**
   * 前往绑定手机提示
   * */
  alertTips = () => {
    this.alertInfo('提示', '请先绑定手机号码');
  };

  /**
   * 通用弹窗提示
   * */
  alertInfo = (title, str) => {
    Modal.info({
      title: `${title}`,
      content: (
        <div>
          <p>{str}</p>
        </div>
      ),
      onOk() {}
    });
  };

  componentDidMount = () => {
    const { $ } = window;
    const { showPop } = this.state;
    let that = this;
    let url = ANTIQUEACCOUNT_URL;
    $('.xsj_register_dom_eight').registerPublic({
      domName: '.xsj_register_dom_eight',
      // ajaxUrl: '//pf-api.xoyo.com/', //用于正式接口
      ajaxUrl: url, //用于测试接口
      regTag: 8,
      loginModel: true,
      isLogin: true,
      client: 'jxsj',
      isLogOutCallback: true, //开启退出回调
      cbLogOut: function() {
        let lastStep = parseInt(sessionStorage.getItem('activateStep'));
        let userLevel = sessionStorage.getItem('userLevel');
        if (lastStep === 2) {
          $$tracker.clickExit1(userLevel);
        } else if (lastStep === 3) {
          $$tracker.clickExit2(userLevel);
        } else if (lastStep === 4) {
          $$tracker.clickExit4(userLevel);
        } else {
          $$tracker.clickExit3(userLevel);
        }
        sessionStorage.clear();
        location.reload();
      },
      onStart: function() {
        if (DeviceUtils.isIOS()) {
          $('.J_loginPubUser').attr('placeholder', '输入账号');
          $('.J_loginPubpass').attr('placeholder', '输入密码');
          $('.J_pcRegLabel').remove();
        }
      },
      cbLoginSuccess: function($user) {
        //用户已登录时回调 isLogin为true，且已登录才会有此回调  参数为用户名
        let lastStep = sessionStorage.getItem('activateStep');
        switch (lastStep) {
          case '2':
            that.getUserStatus();
            break;
          case '3':
            that.activation();
            break;
          case '4':
            that.activation(); // 返回身份验证部分
            break;
          case '5':
            that.getActivateResult();
            break;
          default:
            break;
        }
      },
      cbLoginModelSuccess: function($user) {
        // 计算鉴定账号数
        that.addCount();
        that.showLoading();
        $$tracker.clickIndex();
      }
    });
  };

  render() {
    const { showPop, textValue, appraisalText, bindPhone, userIdCard, showResult, activationText, qrcodeUrl, errorStatus, activateValue } = this.state;
    return (
      <div className={styles.root}>
        <div className={styles.xfe_js_main}>
          <div className={styles.xfe_js_bg} />
          <div className={styles.xfe_js_userText}>
            <div className={styles.xfe_js_userNum}>
              已有<span>{textValue}</span>位大侠进行了账号鉴定
            </div>
          </div>
          <div className={styles.xfe_js_appraisal} data-name="账号鉴定流程">
            <div className={styles.xfe_js_group_6} style={{ display: showPop === 1 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_7} data-name="进度显示" />
              <div className={styles.xfe_js_group_7 + ' xsj_register_dom_eight'} data-name="账号输入" />
              {/*<div className={styles.xfe_js_group_11} data-name="鉴定按钮">*/}
              {/*<div className={styles.xfe_js_layer_15} data-name="按钮背景" />*/}
              {/*<div className={styles.xfe_js_layer_16} data-name="鉴定" />*/}
              {/*</div>*/}
              <div className={styles.xfe_js_layer_17} data-name="如有疑问请拨打服务热线：028-85437733" />
              <a href="//security.xoyo.com/forget-password" target="_blank" className={styles.xfe_js_layer_18}>
                忘记密码？
              </a>
            </div>
            <div className={styles.xfe_js_group_12} data-name="鉴定中(需做成gif)" style={{ display: showPop === 2 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_7} data-name="进度显示" />
              <div className={styles.xfe_js_layer_19} data-name="鉴定中……" />
            </div>
            <div className={styles.xfe_js_group_13} style={{ display: showPop === 3 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_20} data-name="激活特权" />
              <div className={styles.xfe_js_group_14} data-name="文案">
                <div className={styles.xfe_js_layer_21} dangerouslySetInnerHTML={{ __html: this.state.appraisalText }} />
              </div>
              <div className={styles.xfe_js_layer_22} onClick={() => this.activation()} data-name="激活按钮" />
              <div className={styles.xfe_js_layer_23} data-name="扫描二维码分享鉴定结果，邀请好友为你的账号“加价”----------->" />
              <iframe className={styles.xfe_js_layer_24} frameBorder="0" src={qrcodeUrl} />
              <span className={styles.codeLine_24} />

              {/*<div className={styles.xfe_js_layer_24} data-name="二维码" />*/}
            </div>
            <div className={styles.xfe_js_group_15} style={{ display: showPop === 4 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_25} data-name="激活特权" />
              <div className={styles.xfe_js_group_16} data-name="文案">
                <div className={styles.xfe_js_layer_26} dangerouslySetInnerHTML={{ __html: this.state.appraisalText }} />
              </div>
              <div className={styles.xfe_js_layer_27} onClick={() => this.activation()} data-name="激活按钮" />
            </div>
            <div className={styles.xfe_js_group_17} style={{ display: showPop === 5 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_28} data-name="激活特权" />
              <div className={styles.xfe_js_group_18} data-name="手机绑定输入">
                <div className={styles.xfe_js_group_19} data-name="身份证">
                  <input
                    type="text"
                    className={styles.xfe_js_layer_29}
                    placeholder="请输入身份证号码"
                    ref="userIdCard"
                    value={this.state.userIdCard}
                    onChange={e => {
                      this.setState({ userIdCard: e.currentTarget.value, errorStatus: false });
                    }}
                    onBlur={e => {
                      this.isIdCard(e.currentTarget.value);
                    }}
                  />
                  <div className={styles.xfe_js_layer_30} data-name="身份证：" />
                  <span className="error-tips" style={{ display: errorStatus ? 'block' : 'none' }} />
                </div>
                <div className={styles.xfe_js_group_20} data-name="绑定手机">
                  <div className={styles.xfe_js_layer_31}>{bindPhone}</div>
                  <div className={styles.xfe_js_layer_32} data-name="绑定手机：" />
                </div>
                <div className={styles.xfe_js_group_22} data-name="手机验证码">
                  <input type="text" className={styles.xfe_js_layer_35} data-name="矩形 530" />
                  <div className={styles.xfe_js_layer_36} data-name="手机验证码：" />
                  <div className={styles.xfe_js_layer_37}>获取验证码</div>
                  <SmsCodeInput
                    onChange={vCode => {
                      this.setState({ verificationCode: vCode });
                    }}
                    validateAndGetPhone={vCode => {
                      if (!vCode || vCode.length === 0) {
                        this.alertInfo('输入错误', '请输入手机验证码');
                        return undefined;
                      }

                      return vCode;
                    }}
                    idCard={this.state.userIdCard}
                    phone={this.state.phoneCode}
                  />
                </div>
              </div>
              <div className={styles.xfe_js_layer_38} onClick={() => this.checkCode()} data-name="验证按钮" />
              <div className="J_logOutPublicRegjs layer_38">[ 退出登录 ]</div>
              <div className={styles.xfe_js_layer_39} data-name="如有疑问请拨打服务热线：028-85437733" />
              <a href="//security.xoyo.com/phone-setting" target="_blank" className={styles.xfe_js_layer_40}>
                修改绑定手机
              </a>
            </div>
            <div className={styles.xfe_js_group_23} style={{ display: showPop === 6 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_41} data-name="激活特权" />
              <div className={styles.xfe_js_group_24} data-name="输入内容">
                <div className={styles.xfe_js_group_25} data-name="身份证">
                  <input type="text" className={styles.xfe_js_layer_42} />
                  <div className={styles.xfe_js_layer_43} data-name="身份证：" />
                </div>
                <div className={styles.xfe_js_group_26} data-name="绑定手机">
                  <a href="//security.xoyo.com/phone-setting" target="_blank" className={styles.xfe_js_layer_44} />
                  <a href="//security.xoyo.com/phone-setting" target="_blank" className={styles.xfe_js_layer_45}>
                    前往绑定手机
                  </a>
                  <div className={styles.xfe_js_layer_46} data-name="绑定手机：" />
                </div>
                <div className={styles.xfe_js_group_28} data-name="手机验证码">
                  <input type="text" className={styles.xfe_js_layer_49} />
                  <div className={styles.xfe_js_layer_50} onClick={this.alertTips}>
                    获取验证码
                  </div>
                  <div className={styles.xfe_js_layer_51} data-name="手机验证码：" />
                </div>
              </div>
              <div className={styles.xfe_js_layer_52} onClick={this.alertTips} data-name="验证按钮" />
              <div className="J_logOutPublicRegjs layer_38">[ 退出登录 ]</div>
              <div className={styles.xfe_js_layer_53} data-name="如有疑问请拨打服务热线：028-85437733" />
              <a href="//security.xoyo.com/phone-setting" target="_blank" className={styles.xfe_js_layer_54}>
                修改绑定手机
              </a>
            </div>
            <div className={styles.xfe_js_group_29} style={{ display: showPop === 7 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_layer_55} data-name="激活特权" />
              <div className={styles.xfe_js_group_30} data-name="激活框">
                <Radio.Group onChange={this.onChangeValue} value={this.state.activateValue}>
                  <Radio value={1}>
                    <div className={styles.xfe_js_group_32} data-name="激活其他">
                      <div className={styles.xfe_js_layer_64} data-name="激活当前账号" />
                    </div>
                  </Radio>
                  <Radio value={2}>
                    <div className={styles.xfe_js_group_31} data-name="激活本人">
                      <div className={styles.xfe_js_layer_57} data-name="激活其他账号" />
                      <input
                        type="text"
                        className={styles.xfe_js_layer_58}
                        ref="newAccount"
                        value={this.state.newAccount}
                        onChange={e => this.setState({ newAccount: e.target.value })}
                        placeholder="请输入账号"
                        style={{ backgroundColor: activateValue === 2 ? '#f1f1f1' : '#faeddc' }}
                      />
                      <input
                        type="text"
                        className={styles.xfe_js_layer_59}
                        ref="checkNewAccount"
                        value={this.state.checkNewAccount}
                        onChange={e => this.setState({ checkNewAccount: e.target.value })}
                        onBlur={this.checkAccount}
                        placeholder="请再次输入账号"
                        style={{ backgroundColor: activateValue === 2 ? '#f1f1f1' : '#faeddc' }}
                      />
                    </div>
                  </Radio>
                </Radio.Group>
              </div>
              <div className={styles.xfe_js_layer_65} onClick={this.activateAccount} data-name="验证按钮" />
              <div className="J_logOutPublicRegjs layer_38">[ 退出登录 ]</div>
              <div className={styles.xfe_js_layer_66} data-name="温馨提示：若选择激活其他账号，当前账号将不能被再次激活" />
            </div>
            <div className={styles.xfe_js_group_34} style={{ display: showPop === 8 ? 'block' : 'none' }}>
              <div className={styles.xfe_js_group_35} data-name="组 29">
                <div className={styles.xfe_js_layer_67} data-name="激活特权" />
              </div>
              <div className={styles.xfe_js_group_36} data-name="激活结果1" style={{ display: showResult === 1 ? 'block' : 'none' }}>
                <div className={styles.xfe_js_layer_68} />
                <div className={styles.xfe_js_layer_69} dangerouslySetInnerHTML={{ __html: this.state.activationText }} />
              </div>
              <div className={styles.xfe_js_group_37} data-name="激活结果2" style={{ display: showResult === 2 ? 'block' : 'none' }}>
                <div className={styles.xfe_js_layer_70} data-name="峨眉Q" />
                <div className={styles.xfe_js_layer_71} dangerouslySetInnerHTML={{ __html: this.state.activationText }} />
                <div className={styles.xfe_js_layer_72} data-name="扫描二维码分享鉴定结果，邀请好友为你的账号“加价”。" />
                <div className="J_logOutPublicRegjs layer_72">[ 退出登录 ]</div>
                <iframe className={styles.xfe_js_layer_73} frameBorder="no" src={qrcodeUrl} />
                <span className={styles.codeLine_73} />
                {/*<div className={styles.xfe_js_layer_73} data-name="二维码" />*/}
              </div>
              <div className={styles.xfe_js_group_38} data-name="激活结果3" style={{ display: showResult === 3 ? 'block' : 'none' }}>
                <div className={styles.xfe_js_layer_74} data-name="武当Q" />
                {/*<div className={styles.xfe_js_layer_75} data-name="二维码" />*/}
                <iframe className={styles.xfe_js_layer_75} frameBorder="no" src={qrcodeUrl} />
                <span className={styles.codeLine_75} />
                <div className={styles.xfe_js_layer_76} dangerouslySetInnerHTML={{ __html: this.state.activationText }} />
                <div className={styles.xfe_js_layer_77} data-name="扫描二维码分享鉴定结果，邀请好友为你的账号“加价”。" />
              </div>
              <div className={styles.xfe_js_group_39} data-name="激活结果4" style={{ display: showResult === 4 ? 'block' : 'none' }}>
                <div className={styles.xfe_js_layer_78} data-name="天忍Q" />
                <div className={styles.xfe_js_layer_79} dangerouslySetInnerHTML={{ __html: this.state.activationText }} />
                <div className={styles.xfe_js_layer_80} data-name="温馨提示：查看“加价”情况，请登录初始古董账号查看二维码。" />
              </div>
            </div>
          </div>
          <div className={styles.xfe_js_group_40} data-name="账号等级奖励">
            <div className={styles.xfe_js_layer_81} data-name="账号鉴定等级奖励" />
            <div className={styles.xfe_js_layer_82} data-name="装饰" />
            <div className={styles.xfe_js_layer_83}>活动时间：2019年7月16日-7月30日</div>
            <div className={styles.xfe_js_group_41} data-name="活动规则">
              <div className={styles.xfe_js_layer_84} data-name="规则标题" />
              <div className={styles.xfe_js_group_42} data-name="规则文案">
                <div className={styles.xfe_js_layer_85} />
                <div className={styles.xfe_js_layer_86} />
                <div className={styles.xfe_js_layer_87} />
                <div className={styles.xfe_js_layer_88} />
                <div className={styles.xfe_js_layer_89} />
              </div>
            </div>
            <div className={styles.xfe_js_layer_90} data-name="奖励图片" />
          </div>
          <div className={styles.xfe_js_group_43} data-name="好友加价">
            <div className={styles.xfe_js_layer_91} data-name="好友“加价”领额外福利" />
            <div className={styles.xfe_js_group_44} data-name="装饰 拷贝">
              <div className={styles.xfe_js_layer_92} data-name="装饰l" />
              <div className={styles.xfe_js_layer_93} data-name="装饰r" />
            </div>
            <div className={styles.xfe_js_layer_94}>活动时间：2019年7月16日-7月22日</div>
            <div className={styles.xfe_js_group_45} data-name="活动内容">
              <div className={styles.xfe_js_layer_95} data-name="文字两边装饰" />
              <div className={styles.xfe_js_group_46} data-name="规则文案">
                <div className={styles.xfe_js_layer_96} />
                <div
                  className={styles.xfe_js_layer_97}
                  data-name="温馨提示：活动结束后“加价红利”不可转移，建议需要转移账号资格的大侠在活动结束前完成资格转移。"
                />
                <div className={styles.xfe_js_layer_98} data-name="*" />
              </div>
            </div>
            <div className={styles.xfe_js_group_47} data-name="加价步骤">
              <div className={styles.xfe_js_group_48} data-name="第一步" />
              <div className={styles.xfe_js_group_50} data-name="第二步" />
              <div className={styles.xfe_js_group_52} data-name="第三步" />
              <div className={styles.xfe_js_group_54} data-name="第四步" />
            </div>
          </div>
          <div className={styles.xfe_js_group_56} data-name="快捷导航">
            <div className={styles.xfe_js_layer_123} data-name="圆角矩形 2" />
            <div className={styles.xfe_js_group_57} data-name="组 26">
              <a href="//jxsj.xoyo.com/index/" target="-_blank" className={styles.xfe_js_layer_124} data-name="官网" />
              <a href="//jxsj.xoyo.com/download/" target="-_blank" className={styles.xfe_js_layer_125} data-name="下载" />
              <a href="//passport.xoyo.com/signup?origin=jxsj" target="-_blank" className={styles.xfe_js_layer_126} data-name="注册" />
              <a href="//jxsj2.bbs.xoyo.com/" target="-_blank" className={styles.xfe_js_layer_127} data-name="论坛" />
            </div>
          </div>
          <div className={styles.xfe_js_layer_130} data-name="logo" />
          <div className={styles.xfe_js_layer_131} data-name="悬浮框按钮">
            <a href="javaScript:alert('敬请期待！');" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/index.js